import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const KriptoParaNedir = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('kriptoParaNedir.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('kriptoParaNedir.subtitle')}</h3>
                        <p className="academy-intro-text">{t('kriptoParaNedir.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('kriptoParaNedir.intro.p2')}</p>
                    </div>
                </div>

                {/* Bölüm 1: Kripto Para Nedir? */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoParaNedir.section1.title')}</h2>
                        <p className="academy-section-text">{t('kriptoParaNedir.section1.p1')}</p>
                        
                        {/* Karşılaştırma Tablosu */}
                        <div className="academy-table-wrapper mt-4">
                            <table className="academy-table">
                                <thead>
                                    <tr>
                                        <th>{t('kriptoParaNedir.section1.table.header1')}</th>
                                        <th>{t('kriptoParaNedir.section1.table.header2')}</th>
                                        <th>{t('kriptoParaNedir.section1.table.header3')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(t('kriptoParaNedir.section1.table.rows', { returnObjects: true }) || []).map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.col1}</td>
                                            <td>{row.col2}</td>
                                            <td>{row.col3}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Tarihçe */}
                        <h3 className="academy-subsection-title mt-5">{t('kriptoParaNedir.section1.history.title')}</h3>
                        <ul className="academy-list">
                            {(t('kriptoParaNedir.section1.history.items', { returnObjects: true }) || []).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 2: Temel Özellikler */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoParaNedir.section2.title')}</h2>
                        
                        {/* Her özellik için card */}
                        {(t('kriptoParaNedir.section2.features', { returnObjects: true }) || []).map((feature, index) => (
                            <div className="academy-highlight-box mb-4" key={index}>
                                <h4>{feature.title}</h4>
                                <p>{feature.description}</p>
                                {feature.bullets && (
                                    <ul>
                                        {(feature.bullets || []).map((bullet, bIdx) => (
                                            <li key={bIdx}>{bullet}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 3: Öne Çıkan Kripto Paralar */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoParaNedir.section3.title')}</h2>
                        
                        <div className="row g-4">
                            {(t('kriptoParaNedir.section3.coins', { returnObjects: true }) || []).map((coin, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-type-card">
                                        <h4>{coin.name}</h4>
                                        <p>{coin.description}</p>
                                        <div className="mt-3">
                                            <strong>{t('kriptoParaNedir.section3.featuresLabel')}</strong>
                                            <ul className="mt-2">
                                                {(coin.features || []).map((feature, fIdx) => (
                                                    <li key={fIdx}>{feature}</li>
                                                ))}
                                            </ul>
                                        </div>
                                        {coin.note && (
                                            <p className="mt-3 academy-note">{coin.note}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bölüm 4: Kullanım Alanları */}
                <div className="academy-section  mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoParaNedir.section4.title')}</h2>
                        
                        {(t('kriptoParaNedir.section4.useCases', { returnObjects: true }) || []).map((useCase, index) => (
                            <div className="academy-usecase-card mb-3" key={index}>
                                <h4>{useCase.title}</h4>
                                <p>{useCase.description}</p>
                            </div>
                        ))}

                        {/* Dikkat Edilmesi Gerekenler */}
                        <div className="academy-highlight-box  mt-5">
                            <h4>{t('kriptoParaNedir.section4.caution.title')}</h4>
                            <ul>
                                {(t('kriptoParaNedir.section4.caution.items', { returnObjects: true }) || []).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Özet */}
                <div className="academy-summary-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoParaNedir.summary.title')}</h2>
                        <p className="academy-section-text">{t('kriptoParaNedir.summary.p1')}</p>
                        <p className="academy-section-text">{t('kriptoParaNedir.summary.p2')}</p>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default KriptoParaNedir;
